// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e3d441d4","453":"14000d62","455":"9de67d5a","977":"34d2a9ce"}[chunkId] + ".chunk.js";
};